import { apiClient } from './config';
import { getClientType } from '../../../tools/session/clientSession';

const getClientTypeParam = () => getClientType() || 'default';

export const fetchSignals = async () => {
  const clientType = getClientTypeParam();
  const response = await apiClient.get('/signal/all', {
    params: { client_type: clientType }
  });
  return response.data;
};

export const createSignal = async (formData) => {
  const clientType = getClientTypeParam();
  formData.append('client_type', clientType);
  const response = await apiClient.post('/signal', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateSignal = async (formData, id) => {
  const clientType = getClientTypeParam();
  formData.append('client_type', clientType);
  const response = await apiClient.put(`/signal/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteSignal = async (id) => {
  const clientType = getClientTypeParam();
  const response = await apiClient.delete(`/signal/${id}`, {
    params: { client_type: clientType }
  });
  return response.data;
};

export { apiClient, API_BASE_URL, getAuthHeaders } from './config';
